var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ehr-panel"},_vm._l((_vm.menuList),function(path){return _c('ehr-nav-list',{key:path.name,attrs:{"path":path,"level":1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }